import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Link } from 'foundations-components/transitional/components/Link';
import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const InputStyles = styled.div.withConfig({
  displayName: "TextInputstyles__InputStyles",
  componentId: "sc-1c6tlc2-0"
})(["display:inline-block;position:relative;vertical-align:left;border-color:white !important;background-color:white !important;width:100%;input{padding-top:14px !important;padding-bottom:18px !important;", " ", "}.Country,[data-selenium-id='country'],input{", " border:2px solid;border-left:none !important;border-right:none !important;border-top:none !important;", " ", " ", "}.Country,[data-selenium-id='country']{margin-bottom:20px;}div[data-selenium-id='country']:hover{box-shadow:none !important;", " background:white;}div[aria-expanded='true']{", "}input[aria-invalid='true']{border-bottom-color:#bf2434 !important;}input:focus{", "}input[aria-invalid='true'],input[aria-invalid='true']:focus{box-shadow:none !important;}"], props => props.industryStyle && `
      margin-bottom: -3px;
    `, props => props.inputFontSize && `
      font-size: ${props.inputFontSize}px;
    `, props => `
      border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
    `, props => props.success && `
      border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
    `, props => props.error && `
      border-bottom-color: #bf2434 !important;
    `, props => props.disabled && `
      background-color: ${props.theme.color['fill-accent-neutral-subtle-alt']} !important;
      box-shadow: none !important;
      border-bottom-color: #cbd6e2 !important;
    `, props => `
      border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
    `, props => `
      border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
    `, props => props.industryStyle && `
        border-bottom-color: ${props.theme.color['border-accent-blue-default']} !important;
        ${props.success && `
          border-bottom-color: ${props.theme.color['fill-accent-green-hover']} !important;
        `}
        ${props.error && `
          border-bottom-color: #bf2434 !important;
        `}
      `);

/**
 * This component is adapted to not rely on the style overrides from typeahead.scss which
 * modify UIComponents internal classnames.
 *
 * Long-term this component will replace the InputStyles component once all occurrences of
 * InputStyles are removed from the codebase.
 */
export const MigratedInputStyles = styled(InputStyles).withConfig({
  displayName: "TextInputstyles__MigratedInputStyles",
  componentId: "sc-1c6tlc2-1"
})(["input{border:1px solid #fff;background-color:#fff;text-align:left;font-size:22px;padding-left:0px;border-radius:0px;", " &:focus{border-color:#fff;box-shadow:none;}&:hover{border-color:#fff;box-shadow:none;}&:disabled{background-color:#fff;border:1px solid #fff;}}.Country,input{border-bottom-color:", " !important;border:2px solid;border-left:none !important;border-right:none !important;border-top:none !important;", " ", " ", "}"], props => props.inputFontSize && `
      font-size: ${props.inputFontSize}px;
    `, props => props.theme.color['border-info-default'], props => props.success && `
      border-bottom-color: ${props.theme.color['border-positive-default']} !important;
    `, props => props.error && `
      border-bottom-color: #bf2434 !important;
    `, props => props.disabled && `
      background-color: ${props.theme.color['fill-field-disabled']} !important;
      box-shadow: none !important;
      border-bottom-color: #cbd6e2 !important;
    `);
export const StyledLinkText = styled.span.withConfig({
  displayName: "TextInputstyles__StyledLinkText",
  componentId: "sc-1c6tlc2-2"
})(["color:#0b8484;"]);
export const StyledUILink = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Link, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(StyledLinkText, {
      children: children
    })
  }));
};
export const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "TextInputstyles__StyledFormattedMessage",
  componentId: "sc-1c6tlc2-3"
})(["color:#0b8484 !important;"]);